<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I want to thank Michael R. Ritt, a great writer of western fiction and a lifelong friend, whose unceasing encouragement made all the difference in the world.</p>
<p>I also want to thank my mother, JoAnn, for a lifetime of love and encouragement. If there is anything within me that is truly good, I learned it by your example, Mom.</p>
<p>And finally, I would like to thank my readers. I hope I have delivered within these pages a world you easily slip into and characters you won’t quickly forget.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3da5275e